import { useQuery } from '@fv/client-core'
import type { CarrierUserContextDTO } from '@fv/models'

import { userContextKeys } from '@/queryKeys'
import { carrierFetch } from '@/utils/carrierFetch'

async function fetchUserContext() {
  return carrierFetch<CarrierUserContextDTO>(`/context`)
}

export function useUserContext(enabled = true) {
  return useQuery<CarrierUserContextDTO>(
    userContextKeys.all,
    fetchUserContext,
    {
      enabled,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  )
}
